import React, { Component, ReactNode, ReactElement } from 'react'

export default class Heading
    extends
        Component<
            {
                text: string
            },
            {}
        > {

  render() : ReactElement<ReactNode> {
    return (
        <span
            style={{
                fontSize: "4vmin",
                color: "#007"
            }}
        >{this.props.text}</span>
    )
  }
}
